module.exports = __webpack_public_path__ + "static/media/onboard-nodata.0f0e965d.png";